import useTheme from "./useTheme";
import { useRegisterTheme } from "./useRegisterTheme";
export default function useThemeProps() {
  var themeProps = useTheme();
  return useRegisterTheme(themeProps);
}